import styled from "styled-components";

export const Loader = styled.div`
  border: 3px solid #f3f3f3;
  border-top: 3px solid black;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
